import TokenService from '@/services/token.service'
import ApiService from '@/services/api.service'

export default {
    namespaced: true,
	state: {
		accessToken: TokenService.getAccessToken(),
		refreshToken: TokenService.getRefreshToken(),
		user: TokenService.getClaim('user', {}),
		roles: {},
	},
	getters: {
		isLoggedIn: state => !!state.accessToken,
		hasRole: state => role => state.user.roles && state.user.roles.includes(role),
	},
	mutations: {
		setAccessToken(state, accessToken) {
			TokenService.setAccessToken(accessToken)
			state.accessToken = accessToken
			state.user = TokenService.getClaim('user', {})
		},
		removeAccessToken(state) {
			TokenService.removeAccessToken()
			state.accessToken = null
			state.user = {}
		},
		setRefreshToken(state, refreshToken) {
			TokenService.setRefreshToken(refreshToken)
			state.refreshToken = refreshToken
		},
		removeRefreshToken(state) {
			TokenService.removeRefreshToken()
			state.refreshToken = null
		},
		setUser(state, user) {
			state.user = user
		},
		setRoles(state, roles) {
			state.roles = roles
		},
	},
	actions: {
		login({ commit }, credentials) {
			return ApiService.login(credentials)
				.then(data => {				
					if (data.accessToken) {
						commit('setAccessToken', data.accessToken)
					}		
					return Promise.resolve(data)
				}).catch(() => {
					commit('removeAccessToken')
					return Promise.reject()
				})
		},		
		async logout({ commit }) {
			commit('removeAccessToken')
			commit('removeRefreshToken')
		},
		fetchRoles({ commit }) {
			return ApiService.index('/users/roles')
				.then(roles => {
					commit('setRoles', roles)
					return Promise.resolve(roles)
				})
		},
	},
}
